import React from 'react';
import StatsContainer from '@src/containers/Stats';

const Home = () => <StatsContainer />;

export default Home;
